import { render, staticRenderFns } from "./Collars.vue?vue&type=template&id=2fda8632&scoped=true&"
import script from "./Collars.vue?vue&type=script&lang=js&"
export * from "./Collars.vue?vue&type=script&lang=js&"
import style0 from "./Collars.vue?vue&type=style&index=0&id=2fda8632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda8632",
  null
  
)

export default component.exports